import React, { createContext, useContext, useState } from 'react';

interface ModalContextType {
  selectedAssetId: string | null;
  waitingForAI: boolean; // Solo para control de polling

  openAsset: (assetId: string) => void;
  closeModal: () => void;
  setWaitingForAI: (waiting: boolean) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedAssetId, setSelectedAssetId] = useState<string | null>(null);
  const [waitingForAI, setWaitingForAI] = useState(false);

  const openAsset = (bannerId: string) => {
    setSelectedAssetId(bannerId);
    setWaitingForAI(true); // Iniciar polling
  };

  const closeModal = () => {
    setSelectedAssetId(null);
    setWaitingForAI(false);
  };

  return (
    <ModalContext.Provider
      value={{
        selectedAssetId,
        waitingForAI,

        openAsset,
        closeModal,
        setWaitingForAI
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }
  return context;
};
